// extracted by mini-css-extract-plugin
export default {"emptyMessage":"styles_empty-message_ER6RS","icon":"styles_icon_CmHhr","text":"styles_text_snHBQ","message":"styles_message_zxd8g","suggestion":"styles_suggestion_tj1XE"};